// Thin, soft brand-red hairline used to separate page sections.
// Fades gently at both ends with a small centered diamond accent so it reads
// as an elegant separator rather than a hard rule — matches the AZ Gruppe
// visual identity (AZ Red #7A1516).
export const SectionDivider = ({ className = "" }) => (
  <div
    aria-hidden="true"
    className={`az-container py-3 sm:py-4 ${className}`}
    data-testid="section-divider"
  >
    <div className="relative mx-auto flex max-w-4xl items-center justify-center">
      <span
        className="h-px w-full"
        style={{
          background:
            "linear-gradient(90deg, transparent 0%, rgba(122,21,22,0.5) 28%, rgba(122,21,22,0.68) 50%, rgba(122,21,22,0.5) 72%, transparent 100%)",
        }}
      />
      <span className="absolute h-1.5 w-1.5 rotate-45 rounded-[1px] bg-[#7A1516]/80" />
    </div>
  </div>
);
